import type { Permission } from '@idc-forms/permissions'
import { useMemo } from 'react'
import useAuth from '@/features/auth/hooks/use-auth'
import { TYPE_ACCOUNT } from '@/shared/catalogs/type-account'

export function usePermissions() {
  const { auth } = useAuth()

  const isAdmin = auth?.typeAccount === TYPE_ACCOUNT.admin

  const permissionSet = useMemo(() => new Set<string>(auth?.permissions ?? []), [auth?.permissions])

  const has = (permission: Permission): boolean => {
    if (isAdmin) return true
    return permissionSet.has(permission)
  }

  const hasAny = (permissions: Permission[]): boolean => {
    if (isAdmin) return true
    return permissions.some((p) => permissionSet.has(p))
  }

  const hasAll = (permissions: Permission[]): boolean => {
    if (isAdmin) return true
    return permissions.every((p) => permissionSet.has(p))
  }

  return { has, hasAny, hasAll, isAdmin, permissionSet }
}
